// src/AboutSection.js
import React from 'react';
import { useLanguage } from './LanguageContext';
import './AboutSection.css';

// Импортируем все 6 иконок
import icon1 from './assets/feature-icon-1.png';
import icon2 from './assets/feature-icon-2.png';
import icon3 from './assets/feature-icon-3.png';
import icon4 from './assets/feature-icon-4.png';
import icon5 from './assets/feature-icon-5.png';
import icon6 from './assets/feature-icon-6.png';

// Данные для наших 6 преимуществ
const featuresData = [
  { icon: icon1, titleKey: 'feature1Title', textKey: 'feature1Text' },
  { icon: icon2, titleKey: 'feature2Title', textKey: 'feature2Text' },
  { icon: icon3, titleKey: 'feature3Title', textKey: 'feature3Text' },
  { icon: icon4, titleKey: 'feature4Title', textKey: 'feature4Text' },
  { icon: icon5, titleKey: 'feature5Title', textKey: 'feature5Text' },
  { icon: icon6, titleKey: 'feature6Title', textKey: 'feature6Text' },
];

const AboutSection = ({ id }) => {
  const { t } = useLanguage();

  return (
    <section id={id} className="about-section">
      <div className="about-content">
        <div className="about-text">
          <h2>{t('aboutUs')}</h2>
          <p>
            {t('aboutText')}
          </p>
        </div>
        <div className="about-features-grid">
          {featuresData.map((feature, index) => (
            <div className="feature-block" key={index}>
              <img src={feature.icon} alt={t(feature.titleKey)} />
              <h4>{t(feature.titleKey)}</h4>
              <p>{t(feature.textKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;